import { BaseApolloResponse } from '@customer-portal/shared';

export interface SiteMasterListModel
  extends BaseApolloResponse<SiteMasterListItemModel[]> {
  data: SiteMasterListItemModel[];
}

export interface SiteMasterListItemModel {
  id: number;
  siteName: string;
  siteNickname: string;
  companyId: number;
  companyName: string;
  city: string;
  countryId: number;
  countryName: string;
  formattedAddress: string;
  siteState: string;
  siteZip: string;
  addressLine1: string;
  siteOSvCId: number;
  accountDNVID: string;
  siteRepresentativeName: string;
}
